import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";

export interface SignInButtonProps {
  to?: string;
  className?: string;
}

/**
 * "Iniciar sesión" de la barra superior.
 *
 * Va con `as={Link}`: es una NAVEGACIÓN, y como enlace de verdad se puede
 * abrir en otra pestaña, copiar la dirección y anunciar como enlace. El
 * estilo sale del `Button` del sistema, no de clases sueltas aquí.
 */
export function SignInButton({ to = "/login", className }: SignInButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      as={Link}
      to={to}
      variant="ghost"
      size="sm"
      leftIcon={<LogIn />}
      className={className}
    >
      {t("Iniciar sesión")}
    </Button>
  );
}
